import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyAuctionOver from "./component";
import { withRouter } from "react-router-dom";
import { rejectDnpOffer, savePriceView } from "../post-inspection-diy/actions";
import { createOrder } from "../../../components/mobile/seller-package/action";

const mapStateToProps = ({
    postInspectionDiy: {
        isNoBid,
        inspectionResponse,
        auctionResponse
    },
    user: {  mobile,  secureToken }
}) => ({
    isNoBid,
    inspectionResponse,
    auctionResponse,
    mobile,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    savePriceViewConnect: savePriceView,
    rejectDnpOfferConnect: rejectDnpOffer,
    createOrderConenect: createOrder
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyAuctionOver));
